import { DribbbleLogo, GithubLogo, TwitterLogo } from '@phosphor-icons/react';
import { Logo } from '@/components/brand/Logo';

interface LinkGroup {
  heading: string;
  links: ReadonlyArray<{ label: string; href: string }>;
}

const GROUPS: ReadonlyArray<LinkGroup> = [
  {
    heading: 'Product',
    links: [
      { label: 'Features', href: '#features' },
      { label: 'Templates', href: '#templates' },
      { label: 'Integrations', href: '#' },
      { label: 'Changelog', href: '#' },
    ],
  },
  {
    heading: 'Resources',
    links: [
      { label: 'Documentation', href: '#' },
      { label: 'Showcase', href: '#' },
      { label: 'Writing for Web', href: '#' },
      { label: 'Design Systems', href: '#' },
    ],
  },
  {
    heading: 'Company',
    links: [
      { label: 'About', href: '#' },
      { label: 'Careers', href: '#' },
      { label: 'Legal Terms', href: '#' },
      { label: 'Privacy Policy', href: '#' },
    ],
  },
];

export function LandingFooter() {
  return (
    <footer className="border-t border-line bg-canvas pb-8 pt-16 text-sm">
      <div className="mx-auto max-w-container px-6">
        <div className="mb-16 grid grid-cols-2 gap-8 md:grid-cols-5">
          <div className="col-span-2">
            <div className="mb-4">
              <Logo />
            </div>
            <p className="mb-6 max-w-xs text-ink-muted">
              A structural foundation for creative autonomy. Built globally, designed
              precisely.
            </p>
            <div className="flex items-center gap-4 text-ink-faint">
              <a href="#" className="transition-colors hover:text-ink" aria-label="Twitter">
                <TwitterLogo weight="fill" size={18} />
              </a>
              <a href="#" className="transition-colors hover:text-ink" aria-label="GitHub">
                <GithubLogo weight="fill" size={18} />
              </a>
              <a href="#" className="transition-colors hover:text-ink" aria-label="Dribbble">
                <DribbbleLogo weight="fill" size={18} />
              </a>
            </div>
          </div>

          {GROUPS.map((group) => (
            <div key={group.heading}>
              <h5 className="mb-4 font-semibold text-ink">{group.heading}</h5>
              <ul className="space-y-3 text-ink-muted">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <a href={link.href} className="transition-colors hover:text-ink">
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="flex flex-col items-center justify-between gap-4 border-t border-line pt-8 font-mono text-xs text-ink-faint md:flex-row">
          <p>&copy; {new Date().getFullYear()} Portfoli Systems. All rights reserved.</p>
          <div className="flex items-center gap-2">
            <span className="h-2 w-2 rounded-full bg-emerald-500" />
            Systems Operational
          </div>
        </div>
      </div>
    </footer>
  );
}
